import { render, staticRenderFns } from "./AnnouncementEditor.vue?vue&type=template&id=7fb2d495&scoped=true&"
import script from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
export * from "./AnnouncementEditor.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementEditor.vue?vue&type=style&index=0&id=7fb2d495&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb2d495",
  null
  
)

export default component.exports